import classNames from 'classnames';
import React from 'react';

import { ListPanelWrapperProps } from './LinkPanelTypes';

const ListPanelWrapper: React.FC<ListPanelWrapperProps> = ({
    className,
    children,
    contentClassName,
    titleContent,
    titleClassName,
    footerContent,
    footerClassName,
    hideBackground = false,
    contentWrapperAs,
    ...rest
}) => {
    const ContentWrapper = contentWrapperAs ?? 'div';
    return (
        <section className={className} {...rest}>
            {titleContent && (
                <div className={classNames('sgw-list-panel__wrapper--title', titleClassName)}>{titleContent}</div>
            )}
            <div
                className={classNames('sgw-list-panel__wrapper', {
                    'hide-background': hideBackground,
                    'has-footer': !!footerContent,
                })}
            >
                <ContentWrapper
                    className={classNames('sgw-list-panel__wrapper--content', 'unstyled', contentClassName)}
                >
                    {children}
                </ContentWrapper>
                {footerContent && (
                    <div className={classNames('sgw-list-panel__wrapper--footer', footerClassName)}>
                        {footerContent}
                    </div>
                )}
                <div className={classNames('sgw-list-panel__background', { 'has-title': !!titleContent })} />
            </div>
        </section>
    );
};

export default ListPanelWrapper;
